import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/components/pages/authentication/authentication/authentication.service';
import { Production, ProductionDetail } from 'src/app/models/production';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductionProcessService } from 'src/app/services/production-process.service';
import { ProductionService } from 'src/app/services/production.service';

interface DetailTemp {
  id: number;
  productionId: number;
  quantity: number;
  realCost: number;
  totalCostReal: number;
}

@Component({
  selector: 'app-production-details',
  templateUrl: './production-details.component.html',
  styleUrls: ['./production-details.component.scss']
})
export class ProductionDetailsComponent {
  @Input() details: ProductionDetail[] = [];
  @Input() productionId: number;

  constructor(
    private toastService: ToastrService,
    private productionService: ProductionService,
    private productionProcessService: ProductionProcessService,
    private authService: AuthenticationService,
  ) { }

  editing: { [key: number]: boolean } = {};
  detailTemp: { [key: number]: DetailTemp } = {};

  setEditing(item: ProductionDetail) {
    this.editing[item.id] = true;
    this.detailTemp[item.id] = {
      id: item.id,
      productionId: item.productionId,
      quantity: item.quantity,
      realCost: item.realCost,
      totalCostReal: item.totalCostReal
    }
  }

  changeInput(item: ProductionDetail) {
    item.totalCostReal = item.quantity * item.realCost;
  }

  cancelEditing(item: ProductionDetail) {
    this.editing[item.id] = false;
    item.quantity = this.detailTemp[item.id].quantity;
    item.realCost = this.detailTemp[item.id].realCost;
    item.totalCostReal = this.detailTemp[item.id].totalCostReal;
  }

  saveChanges(item: ProductionDetail) {
    const data = {
      // quantity: item.realQuantity,
      cost: item.realCost
    }

    this.productionProcessService.updateQuantityCostProductionDetail(item.id, data).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Datos Actualizados Correcta", "Exito");
        this.editing[item.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Erro al actualizar los datos", "Error");
      }
    });
  }
}
